import 'normalize.css/normalize.css'

import '@/assets/css/global.css'
import '@/assets/css/ui.css'

import {
    apiUserinfo,
    apiTaskinfo,
} from '@/api/index';
import {
token_type,
issn,
} from '@/api/config';

import Vue from 'vue'
import App from './index.vue'

import router from '@/components/router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

//clipboard
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;

let mainApp = null;

import '@/directives/index'

//wx_share
import wx from '@/assets/js/wxapi.jsonp.js';

//axios
import axios from 'axios';
Vue.prototype.$axios = axios;

import GLOBAL from '@/assets/js/global.js'
Vue.prototype.$global = GLOBAL
Vue.prototype.$queryArea = GLOBAL.queryArea;

//ajxa_map
globalThis.ajax_url_map = GLOBAL.ajax_url_map;

//store
import store from "@/assets/js/store.js";
Vue.prototype.$store = store;

//FREE
import Free_login from '@/assets/js/freeLogin.js';

//login
import mslogin from '@/assets/js/msLogin.js';
Vue.prototype.$mslogin = mslogin;
mslogin.defaults.loginUrl = GLOBAL.ajax_url_map.login;

//utils
import utils from '@/assets/js/utils.js';
Object.keys(utils).forEach(key => {
  Vue.prototype[key] = utils[key]
})

import vuescroll from 'vuescroll';
Vue.use(vuescroll, {
  ops: {
    rail: {
      opacity: 0.6,
      background: '#d6d4cc',
      size: '6px',
      gutterOfSide: '0px',
    },
    bar: {
      background: '#cc3628',
      keepShow: true,
      size: '6px',
    }
  }, // 在这里设置全局默认配置
  name: 'vuescroll' // 在这里自定义组件名字，默认是vueScroll 
});

//user_info
import User_info from '@/components/userinfo.vue';
Vue.component('user-info', User_info);

//item_view
import gameItem from '@/components/itemview.vue'
Vue.component('game-item', gameItem)

Vue.prototype.$update_evt = function (data) {
  mainApp.user_init();
};

Vue.prototype.$update_task = function (data) {
  mainApp.user_init();
};

Vue.prototype.$query_skin = function (data) {
  mainApp.$refs.app.$refs.shop.$refs.rebate.query_skin();
};

mainApp = new Vue({
    el: '#app',
    router,
    components: {
      App
    },
    template: '<App ref="app" :ready="ready"/>',
    data() {
      return {
        ua: {},
        evt_info: {},
        code: '',
        name: null,
        login: 0, //登陆
        aid: 0, //大区id
        account_type: 'pc',
        isLoading: false,
        ready: false, //通信阀门
        share_id: 'ME21',
        key: '',
        share: '',
        token: '',
      }
    },
    created() {
      var _this = this;

      let token = GLOBAL.getQueryVariable('authorization') || localStorage.getItem(token_type);
      _this.token = token

      let code = GLOBAL.getQueryVariable('code') || localStorage.getItem("code");

      if (GLOBAL.getQueryVariable('code')) {
        this.$store.commit("$_setCode", GLOBAL.getQueryVariable('code'));
        localStorage.setItem('code', code);
      }

      this.key = code;

      if (token) {
        localStorage.setItem(token_type, token);
        _this.$store.commit("$_setToken", token);
      }

      window.history.pushState({}, 0, GLOBAL.domain);
    },
    mounted() {
      this.get_user_info();
      let url = GLOBAL.domain.indexOf('http') < 0 ? 'https:' + GLOBAL.domain : GLOBAL.domain;
      wx.wxInit({
        title: GLOBAL.wx_share_text.title, // 分享标题
        desc: GLOBAL.wx_share_text.desc, // 分享描述
        link: url, // 分享链接
        imgUrl: GLOBAL.wx_share_text.imgUrl, // 分享图标            
      });
           
    },
    methods: {
      get_user_info() {
        // 调用免登录接口，进行免登录验证
        //TODO 梦平台免登录
        let _this = this;

        this.ua.uid = this.ua.uid || 0;

        Free_login.free_login_lazy(
          this.$store.state.userinfo.accountid, {
            mplat: ajax_url_map.mplat,
            kd: ajax_url_map.free,
            wx : ajax_url_map.wx,
            issn : issn,   
          },
          function (response) {
            if (typeof response !== 'undefined') {
              _this.token = response.data ? response.data : response;
              localStorage.setItem('token', _this.token);
              _this.$store.commit("$_setToken", _this.token);
            }
            _this.user_init();

          }
        );
      },
      user_init() {

        apiUserinfo().then(
          res => {
            this.$store.commit("$_setUserinfo", res.data);
            this.$store.commit("$_setLogin", 1);

            this.task_init();

            if(localStorage.getItem("code"))return this.$invite_apply({ code : localStorage.getItem("code") });            
          },
          rej => {
            this.task_init();

            console.log(rej)

            if (rej.code != 401 && rej.code != 402) this.$toast(rej.message);

            if (rej.data) {
              this.$store.commit("$_setUserinfo", rej.data);
              this.$store.commit("$_setAid", 0);
              this.$store.commit("$_setLogin", 1);
            }

            if (rej.code == 402 && !localStorage.getItem("code")) {
              this.$bind_modal();
            }

            if(localStorage.getItem("code"))return this.$invite_apply({ code : localStorage.getItem("code") });            
          },
        );

      },
      task_init() {
        apiTaskinfo({s : true}).then(
          res => {
            this.ready = true;
            this.$store.commit("$_setTask", res.data);
          },
          rej => {

          }
        )
      },
    },
  })